<form [formGroup]="form">
  <div class="flex flex-column gap-2">
    <div class="w-full">
      <smm-text-input
        [label]="'LABELS.NEWSLETTER'"
        [formControl]="formControlData('email')"
        [control]="formControlData('email')"
        [placeHolder]="'PLACEHOLDERS.EMAIL'"
        [customeClass]="'newsletter__input'"
        [isNewsletter]="true"
      ></smm-text-input>
    </div>
    <div class="flex justify-content-end">
      <button class="smm-btn" (click)="onSubmit()" [class.cursor-not-allowed]="form.invalid">
        {{ 'BUTTONS.SUBMIT' | translate }}
      </button>
    </div>
  </div>
</form>
